import { render, staticRenderFns } from "./ReceivedEmailsList.vue?vue&type=template&id=323dc911&"
import script from "./ReceivedEmailsList.vue?vue&type=script&lang=js&"
export * from "./ReceivedEmailsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('323dc911')) {
      api.createRecord('323dc911', component.options)
    } else {
      api.reload('323dc911', component.options)
    }
    module.hot.accept("./ReceivedEmailsList.vue?vue&type=template&id=323dc911&", function () {
      api.rerender('323dc911', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/emails/vistas/receivedEmails/ReceivedEmailsList.vue"
export default component.exports